export enum LeaderboardType {
  RecentWinners = 'recent_winners',
}
